import { render } from "./distribute_client.vue?vue&type=template&id=9bb54a68"
import script from "./distribute_client.vue?vue&type=script&lang=js"
export * from "./distribute_client.vue?vue&type=script&lang=js"

import exportComponent from "/drone/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__